export default "__VITE_ASSET__b5f9b336__"